export default {
  'Please select an output format': 'Выберите выходной формат:',
}